import { Application } from '@hotwired/stimulus';

const application = Application.start();

// Configure Stimulus development experience
application.debug = process.env.NODE_ENV === 'development';
window.Stimulus = application;

// eslint-disable-next-line import/prefer-default-export
export { application };
